<template>
  <panel v-if="client" width="400" class="client">
    <div class="options">
      <button @click="saveClient(client)"><i class="far fa-save"></i></button>
      <div class="spacer"></div>
      <button v-if="deletable" @click="deleteClient(client)" class="delete"><i class="far fa-trash"></i></button>
    </div>

    <input-group name="client-company" displayName="Company" placeholder="Company" v-model="client.company"></input-group>
    <input-group name="client-attn" displayName="Attn" placeholder="Attn" v-model="client.with_regards_to"></input-group>
    <input-group name="client-street" displayName="Street" placeholder="Street" v-model="client.street"></input-group>
    <input-group name="client-house-number" displayName="House Number" placeholder="House Number" v-model="client.house_number"></input-group>
    <input-group name="client-postal-code" displayName="Postal Code" placeholder="Postal Code" v-model="client.postal_code"></input-group>
    <input-group name="client-city" displayName="City" placeholder="City" v-model="client.city"></input-group>
    <input-group name="client-country" displayName="Country" placeholder="Country" v-model="client.country"></input-group>
    <input-group name="client-vat" displayName="VAT" placeholder="VAT" v-model="client.VAT"></input-group>
    <input-group name="client-phone" displayName="Phone" placeholder="Phone" v-model="client.phone"></input-group>
    <input-group name="client-email" displayName="Email" placeholder="Email" v-model="client.email"></input-group>
  </panel>
</template>

<script>
import InputGroup from "@/components/inputs/InputGroup"
import Panel from "@/components/layout/Panel"
export default {
  name: 'ClientForm',
  props: ['value', 'invoices'],
  components: {
    InputGroup,
    Panel
  },
  data() {
    return {

    }
  },
  computed: {
    deletable () {
      return this.invoices.length === 0
    },
    client: {
      get() {
        return this.value;
      },
      set(client) {
        this.$emit("input", client);
      }
    }
  },
  methods: {
    saveClient(client) {
      this.$store.dispatch("updateClient", client);
    },
    deleteClient(client) {
      this.$store.dispatch("deleteClient", client);
      this.client = null
    },
  }
}
</script>

<style scoped>

</style>